<template>
  <b-form-group label="Value:">
    <b-form-checkbox
      v-model="value"
      :value="1"
      :unchecked-value="0"
      @input="onInput($event)"
    >
    </b-form-checkbox>
  </b-form-group>
</template>

<script>
export default {
  name: 'SettingFieldBoolean',
  props: {
    initialValue: {
      validator: (prop) =>
        typeof prop === 'string' || typeof prop === 'number' || prop === null,
      default: null,
    },
  },
  data: function () {
    return {
      value: this.initialValue,
    };
  },
  methods: {
    onInput(newValue) {
      this.$emit('input', newValue);
      this.$emit('valid', true);
    },
  },
};
</script>

<style scoped></style>
